/*!
 * assert.js - assertions for javascript
 * Copyright (c) 2018, Christopher Jeffrey (MIT License).
 * https://github.com/chjj/bsert
 */
'use strict';
/**
 * AssertionError
 */

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _assertThisInitialized = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var AssertionError = /*#__PURE__*/function (_Error) {
  _inherits(AssertionError, _Error);

  var _super = _createSuper(AssertionError);

  function AssertionError(options) {
    var _this;

    _classCallCheck(this, AssertionError);

    if (typeof options === 'string') options = {
      message: options
    };
    if (options === null || typeof options !== 'object') options = {};
    var message = null;
    var operator = 'fail';
    var generatedMessage = Boolean(options.generatedMessage);
    if (options.message != null) message = toString(options.message);
    if (typeof options.operator === 'string') operator = options.operator;

    if (message == null) {
      if (operator === 'fail') {
        message = 'Assertion failed.';
      } else {
        var a = stringify(options.actual);
        var b = stringify(options.expected);
        message = "".concat(a, " ").concat(operator, " ").concat(b);
      }

      generatedMessage = true;
    }

    _this = _super.call(this, message);
    var start = _this.constructor;
    if (typeof options.stackStartFunction === 'function') start = options.stackStartFunction;else if (typeof options.stackStartFn === 'function') start = options.stackStartFn;
    _this.type = 'AssertionError';
    _this.name = 'AssertionError [ERR_ASSERTION]';
    _this.code = 'ERR_ASSERTION';
    _this.generatedMessage = generatedMessage;
    _this.actual = options.actual;
    _this.expected = options.expected;
    _this.operator = operator;
    if (Error.captureStackTrace) Error.captureStackTrace(_assertThisInitialized(_this), start);
    return _this;
  }

  return AssertionError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/*
 * Assert
 */


function assert(value, message) {
  if (!value) {
    var generatedMessage = false;

    if (arguments.length === 0) {
      message = 'No value argument passed to `assert()`.';
      generatedMessage = true;
    } else if (message == null) {
      message = 'Assertion failed.';
      generatedMessage = true;
    } else if (isError(message)) {
      throw message;
    }

    throw new AssertionError({
      message: message,
      actual: value,
      expected: true,
      operator: '==',
      generatedMessage: generatedMessage,
      stackStartFn: assert
    });
  }
}

function equal(actual, expected, message) {
  if (!Object.is(actual, expected)) {
    if (isError(message)) throw message;
    throw new AssertionError({
      message: message,
      actual: actual,
      expected: expected,
      operator: 'strictEqual',
      stackStartFn: equal
    });
  }
}

function notEqual(actual, expected, message) {
  if (Object.is(actual, expected)) {
    if (isError(message)) throw message;
    throw new AssertionError({
      message: message,
      actual: actual,
      expected: expected,
      operator: 'notStrictEqual',
      stackStartFn: notEqual
    });
  }
}

function fail(message) {
  var generatedMessage = false;
  if (isError(message)) throw message;

  if (message == null) {
    message = 'Assertion failed.';
    generatedMessage = true;
  }

  throw new AssertionError({
    message: message,
    actual: false,
    expected: true,
    operator: 'fail',
    generatedMessage: generatedMessage,
    stackStartFn: fail
  });
}

function throws(func, expected, message) {
  if (typeof expected === 'string') {
    message = expected;
    expected = undefined;
  }

  var thrown = false;
  var err = null;
  enforce(typeof func === 'function', 'func', 'function');

  try {
    func();
  } catch (e) {
    thrown = true;
    err = e;
  }

  if (!thrown) {
    var generatedMessage = false;

    if (message == null) {
      message = 'Missing expected exception.';
      generatedMessage = true;
    }

    throw new AssertionError({
      message: message,
      actual: undefined,
      expected: expected,
      operator: 'throws',
      generatedMessage: generatedMessage,
      stackStartFn: throws
    });
  }

  if (!testError(err, expected, message, throws)) throw err;
}

function doesNotThrow(func, expected, message) {
  if (typeof expected === 'string') {
    message = expected;
    expected = undefined;
  }

  var thrown = false;
  var err = null;
  enforce(typeof func === 'function', 'func', 'function');

  try {
    func();
  } catch (e) {
    thrown = true;
    err = e;
  }

  if (!thrown) return;

  if (testError(err, expected, message, doesNotThrow)) {
    var generatedMessage = false;

    if (message == null) {
      message = 'Got unwanted exception.';
      generatedMessage = true;
    }

    throw new AssertionError({
      message: message,
      actual: err,
      expected: expected,
      operator: 'doesNotThrow',
      generatedMessage: generatedMessage,
      stackStartFn: doesNotThrow
    });
  }

  throw err;
}

function rejects(_x, _x2, _x3) {
  return _rejects.apply(this, arguments);
}

function _rejects() {
  _rejects = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(func, expected, message) {
    var thrown, err, generatedMessage;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (typeof expected === 'string') {
              message = expected;
              expected = undefined;
            }

            thrown = false;
            err = null;
            if (typeof func !== 'function') enforce(isPromise(func), 'func', 'promise');
            _context.prev = 4;

            if (!isPromise(func)) {
              _context.next = 10;
              break;
            }

            _context.next = 8;
            return func;

          case 8:
            _context.next = 12;
            break;

          case 10:
            _context.next = 12;
            return func();

          case 12:
            _context.next = 18;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](4);
            thrown = true;
            err = _context.t0;

          case 18:
            if (thrown) {
              _context.next = 22;
              break;
            }

            generatedMessage = false;

            if (message == null) {
              message = 'Missing expected rejection.';
              generatedMessage = true;
            }

            throw new AssertionError({
              message: message,
              actual: undefined,
              expected: expected,
              operator: 'rejects',
              generatedMessage: generatedMessage,
              stackStartFn: rejects
            });

          case 22:
            if (testError(err, expected, message, rejects)) {
              _context.next = 24;
              break;
            }

            throw err;

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 14]]);
  }));
  return _rejects.apply(this, arguments);
}

function doesNotReject(_x4, _x5, _x6) {
  return _doesNotReject.apply(this, arguments);
}

function _doesNotReject() {
  _doesNotReject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(func, expected, message) {
    var thrown, err, generatedMessage;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (typeof expected === 'string') {
              message = expected;
              expected = undefined;
            }

            thrown = false;
            err = null;
            if (typeof func !== 'function') enforce(isPromise(func), 'func', 'promise');
            _context2.prev = 4;

            if (!isPromise(func)) {
              _context2.next = 10;
              break;
            }

            _context2.next = 8;
            return func;

          case 8:
            _context2.next = 12;
            break;

          case 10:
            _context2.next = 12;
            return func();

          case 12:
            _context2.next = 18;
            break;

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](4);
            thrown = true;
            err = _context2.t0;

          case 18:
            if (thrown) {
              _context2.next = 20;
              break;
            }

            return _context2.abrupt("return");

          case 20:
            if (!testError(err, expected, message, doesNotReject)) {
              _context2.next = 24;
              break;
            }

            generatedMessage = false;

            if (message == null) {
              message = 'Got unwanted rejection.';
              generatedMessage = true;
            }

            throw new AssertionError({
              message: message,
              actual: undefined,
              expected: expected,
              operator: 'doesNotReject',
              generatedMessage: generatedMessage,
              stackStartFn: doesNotReject
            });

          case 24:
            throw err;

          case 25:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[4, 14]]);
  }));
  return _doesNotReject.apply(this, arguments);
}

function ifError(err) {
  if (err != null) {
    var message = 'ifError got unwanted exception: ';

    if (typeof err === 'object' && typeof err.message === 'string') {
      if (err.message.length === 0 && err.constructor) message += err.constructor.name;else message += err.message;
    } else {
      message += stringify(err);
    }

    throw new AssertionError({
      message: message,
      actual: err,
      expected: null,
      operator: 'ifError',
      generatedMessage: true,
      stackStartFn: ifError
    });
  }
}

function deepEqual(actual, expected, message) {
  if (!isDeepEqual(actual, expected, false)) {
    if (isError(message)) throw message;
    throw new AssertionError({
      message: message,
      actual: actual,
      expected: expected,
      operator: 'deepStrictEqual',
      stackStartFn: deepEqual
    });
  }
}

function notDeepEqual(actual, expected, message) {
  if (isDeepEqual(actual, expected, true)) {
    if (isError(message)) throw message;
    throw new AssertionError({
      message: message,
      actual: actual,
      expected: expected,
      operator: 'notDeepStrictEqual',
      stackStartFn: notDeepEqual
    });
  }
}

function bufferEqual(actual, expected, enc, message) {
  if (!isEncoding(enc)) {
    message = enc;
    enc = null;
  }

  if (enc == null) enc = 'hex';
  expected = bufferize(actual, expected, enc);
  enforce(isBuffer(actual), 'actual', 'buffer');
  enforce(isBuffer(expected), 'expected', 'buffer');

  if (actual !== expected && !actual.equals(expected)) {
    if (isError(message)) throw message;
    throw new AssertionError({
      message: message,
      actual: actual.toString(enc),
      expected: expected.toString(enc),
      operator: 'bufferEqual',
      stackStartFn: bufferEqual
    });
  }
}

function notBufferEqual(actual, expected, enc, message) {
  if (!isEncoding(enc)) {
    message = enc;
    enc = null;
  }

  if (enc == null) enc = 'hex';
  expected = bufferize(actual, expected, enc);
  enforce(isBuffer(actual), 'actual', 'buffer');
  enforce(isBuffer(expected), 'expected', 'buffer');

  if (actual === expected || actual.equals(expected)) {
    if (isError(message)) throw message;
    throw new AssertionError({
      message: message,
      actual: actual.toString(enc),
      expected: expected.toString(enc),
      operator: 'notBufferEqual',
      stackStartFn: notBufferEqual
    });
  }
}

function enforce(value, name, type) {
  if (!value) {
    var msg;

    if (name == null) {
      msg = 'Invalid type for parameter.';
    } else {
      if (type == null) msg = "Invalid type for \"".concat(name, "\".");else msg = "\"".concat(name, "\" must be a(n) ").concat(type, ".");
    }

    var err = new TypeError(msg);
    if (Error.captureStackTrace) Error.captureStackTrace(err, enforce);
    throw err;
  }
}

function range(value, name) {
  if (!value) {
    var msg = name != null ? "\"".concat(name, "\" is out of range.") : 'Parameter is out of range.';
    var err = new RangeError(msg);
    if (Error.captureStackTrace) Error.captureStackTrace(err, range);
    throw err;
  }
}
/*
 * Stringification
 */


function stringify(value) {
  switch (typeof value) {
    case 'undefined':
      return 'undefined';

    case 'object':
      if (value === null) return 'null';
      return "[".concat(objectName(value), "]");

    case 'boolean':
      return "".concat(value);

    case 'number':
      return "".concat(value);

    case 'string':
      if (value.length > 80) value = "".concat(value.substring(0, 77), "...");
      return JSON.stringify(value);

    case 'symbol':
      return tryString(value);

    case 'function':
      return "[".concat(funcName(value), "]");

    case 'bigint':
      return "".concat(value, "n");

    default:
      return "[".concat(typeof value, "]");
  }
}

function toString(value) {
  if (typeof value === 'string') return value;
  if (isError(value)) return tryString(value);
  return stringify(value);
}

function tryString(value) {
  try {
    return String(value);
  } catch (e) {
    return 'Object';
  }
}
/*
 * Error Testing
 */


function testError(err, expected, message, func) {
  if (expected == null) return true;
  if (isRegExp(expected)) return expected.test(err);

  if (typeof expected !== 'function') {
    if (func === doesNotThrow || func === doesNotReject) throw new TypeError('"expected" must not be an object.');
    if (typeof expected !== 'object') throw new TypeError('"expected" must be an object.');
    var generatedMessage = false;

    if (message == null) {
      var name = func === rejects ? 'rejection' : 'exception';
      message = "Missing expected ".concat(name, ".");
      generatedMessage = true;
    }

    if (err == null || typeof err !== 'object') {
      throw new AssertionError({
        actual: err,
        expected: expected,
        message: message,
        operator: func.name,
        generatedMessage: generatedMessage,
        stackStartFn: func
      });
    }

    var keys = Object.keys(expected);
    if (isError(expected)) keys.push('name', 'message');
    if (keys.length === 0) throw new TypeError('"expected" may not be an empty object.');

    for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
      var key = _keys[_i];
      var expect = expected[key];
      var value = err[key];

      if (typeof value === 'string' && isRegExp(expect) && expect.test(value)) {
        continue;
      }

      if (key in err && isDeepEqual(value, expect, false)) continue;
      throw new AssertionError({
        actual: err,
        expected: expected,
        message: message,
        operator: func.name,
        generatedMessage: generatedMessage,
        stackStartFn: func
      });
    }

    return true;
  }

  if (expected.prototype !== undefined && err instanceof expected) return true;
  if (Error.isPrototypeOf(expected)) return false;
  return expected.call({}, err) === true;
}
/*
 * Comparisons
 */


function isDeepEqual(x, y, fail) {
  try {
    return compare(x, y, null);
  } catch (e) {
    return fail;
  }
}

function compare(a, b, cache) {
  // Primitives.
  if (Object.is(a, b)) return true;
  if (!isObject(a) || !isObject(b)) return false; // Semi-primitives.

  if (objectString(a) !== objectString(b)) return false;
  if (Object.getPrototypeOf(a) !== Object.getPrototypeOf(b)) return false;
  if (isBuffer(a) && isBuffer(b)) return a.equals(b);
  if (isDate(a)) return Object.is(a.getTime(), b.getTime());

  if (isRegExp(a)) {
    return a.source === b.source && a.global === b.global && a.multiline === b.multiline && a.lastIndex === b.lastIndex && a.ignoreCase === b.ignoreCase;
  }

  if (isError(a)) {
    if (a.message !== b.message) return false;
  }

  if (isArrayBuffer(a)) {
    a = new Uint8Array(a);
    b = new Uint8Array(b);
  }

  if (isView(a) && !isBuffer(a)) {
    if (isBuffer(b)) return false;
    var x = new Uint8Array(a.buffer);
    var y = new Uint8Array(b.buffer);
    if (x.length !== y.length) return false;

    for (var i = 0; i < x.length; i++) {
      if (x[i] !== y[i]) return false;
    }

    return true;
  }

  if (isSet(a)) {
    if (a.size !== b.size) return false;
    var keys = new Set([].concat(_toConsumableArray(a), _toConsumableArray(b)));
    return keys.size === a.size;
  } // Recursive.


  if (!cache) {
    cache = {
      a: new Map(),
      b: new Map(),
      p: 0
    };
  } else {
    var aa = cache.a.get(a);

    if (aa != null) {
      var bb = cache.b.get(b);
      if (bb != null) return aa === bb;
    }

    cache.p += 1;
  }

  cache.a.set(a, cache.p);
  cache.b.set(b, cache.p);
  var ret = recurse(a, b, cache);
  cache.a.delete(a);
  cache.b.delete(b);
  return ret;
}

function recurse(a, b, cache) {
  if (isMap(a)) {
    if (a.size !== b.size) return false;

    var _keys2 = new Set([].concat(_toConsumableArray(a.keys()), _toConsumableArray(b.keys())));

    if (_keys2.size !== a.size) return false;

    var _iterator = _createForOfIteratorHelper(_keys2),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        if (!compare(a.get(key), b.get(key), cache)) return false;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return true;
  }

  if (isArray(a)) {
    if (a.length !== b.length) return false;

    for (var i = 0; i < a.length; i++) {
      if (!compare(a[i], b[i], cache)) return false;
    }

    return true;
  }

  var ak = ownKeys(a);
  var bk = ownKeys(b);
  if (ak.length !== bk.length) return false;
  var keys = new Set([].concat(_toConsumableArray(ak), _toConsumableArray(bk)));
  if (keys.size !== ak.length) return false;

  var _iterator2 = _createForOfIteratorHelper(keys),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _key = _step2.value;
      if (!compare(a[_key], b[_key], cache)) return false;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return true;
}

function ownKeys(obj) {
  var keys = Object.keys(obj);
  if (!Object.getOwnPropertySymbols) return keys;
  if (!Object.getOwnPropertyDescriptor) return keys;
  var symbols = Object.getOwnPropertySymbols(obj);

  var _iterator3 = _createForOfIteratorHelper(symbols),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var symbol = _step3.value;
      var desc = Object.getOwnPropertyDescriptor(obj, symbol);
      if (desc && desc.enumerable) keys.push(symbol);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return keys;
}
/*
 * Helpers
 */


function objectString(obj) {
  if (obj === undefined) return '[object Undefined]';
  if (obj === null) return '[object Null]';

  try {
    return Object.prototype.toString.call(obj);
  } catch (e) {
    return '[object Object]';
  }
}

function objectType(obj) {
  return objectString(obj).slice(8, -1);
}

function objectName(obj) {
  var type = objectType(obj);
  if (obj == null) return type;
  if (type !== 'Object' && type !== 'Error') return type;
  var ctor, name;

  try {
    ctor = obj.constructor;
  } catch (e) {
    ;
  }

  if (ctor == null) return type;

  try {
    name = ctor.name;
  } catch (e) {
    return type;
  }

  if (typeof name !== 'string' || name.length === 0) return type;
  return name;
}

function funcName(func) {
  var name;

  try {
    name = func.name;
  } catch (e) {
    ;
  }

  if (typeof name !== 'string' || name.length === 0) return 'Function';
  return "Function: ".concat(name);
}

function isArray(obj) {
  return Array.isArray(obj);
}

function isArrayBuffer(obj) {
  return obj instanceof ArrayBuffer;
}

function isBuffer(obj) {
  return isObject(obj) && typeof obj.writeUInt32LE === 'function' && typeof obj.equals === 'function';
}

function isDate(obj) {
  return obj instanceof Date;
}

function isError(obj) {
  return obj instanceof Error;
}

function isMap(obj) {
  return obj instanceof Map;
}

function isObject(obj) {
  return obj && typeof obj === 'object';
}

function isPromise(obj) {
  return obj instanceof Promise;
}

function isRegExp(obj) {
  return obj instanceof RegExp;
}

function isSet(obj) {
  return obj instanceof Set;
}

function isView(obj) {
  return ArrayBuffer.isView(obj);
}

function isEncoding(enc) {
  if (typeof enc !== 'string') return false;

  switch (enc) {
    case 'ascii':
    case 'binary':
    case 'base64':
    case 'hex':
    case 'latin1':
    case 'ucs2':
    case 'utf8':
    case 'utf16le':
      return true;
  }

  return false;
}

function bufferize(actual, expected, enc) {
  if (typeof expected === 'string') {
    if (!isBuffer(actual)) return null;
    var _constructor = actual.constructor;
    if (!_constructor || typeof _constructor.from !== 'function') return null;
    if (!isEncoding(enc)) return null;
    if (enc === 'hex' && expected.length & 1) return null;

    var raw = _constructor.from(expected, enc);

    if (enc === 'hex' && raw.length !== expected.length >>> 1) return null;
    return raw;
  }

  return expected;
}
/*
 * API
 */


assert.AssertionError = AssertionError;
assert.assert = assert;
assert.strict = assert;
assert.ok = assert;
assert.equal = equal;
assert.notEqual = notEqual;
assert.strictEqual = equal;
assert.notStrictEqual = notEqual;
assert.fail = fail;
assert.throws = throws;
assert.doesNotThrow = doesNotThrow;
assert.rejects = rejects;
assert.doesNotReject = doesNotReject;
assert.ifError = ifError;
assert.deepEqual = deepEqual;
assert.notDeepEqual = notDeepEqual;
assert.deepStrictEqual = deepEqual;
assert.notDeepStrictEqual = notDeepEqual;
assert.bufferEqual = bufferEqual;
assert.notBufferEqual = notBufferEqual;
assert.enforce = enforce;
assert.range = range;
/*
 * Expose
 */

module.exports = assert;